export const LOAD_PRODUCTS = "LOAD_PRODUCTS";
export const ADD_TO_CART = "ADD_TO_CART";
export const DELETE_FROM_CART = "DELETE_FROM_CART";
export const ADJUST_QUANTITY = "ADJUST_QUANTITY";
export const LOAD_CURRENT_ITEM = "LOAD_CURRENT_ITEM";